<template>
  <div>
    <UsersForm
      v-if="user"
      :user="user"
      :user-id="user.id"
      label="Edit User"
      :on-success="onSuccess"
    />
    <div v-if="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UsersForm from '@/components/admin/users/users-form';

export default {
  name: 'AdminEditUser',
  components: { UsersForm },
  props: ['userId'],
  data() {
    return {
      user: this.userData,
      loading: true,
      error: null
    };
  },
  computed: {
    ...mapState({
      userData: state => state.users.user
    })
  },
  watch: {
    userData(user) {
      this.user = user;
    }
  },
  mounted() {
    this.getUser();
  },
  methods: {
    getUser() {
      this.$store.dispatch('users/fetchUserData', { userId: this.userId }).then(
        () => {},
        response => {
          switch (response.status) {
            case 403:
              this.error = 'You are not able to edit this user.';
              break;
            case 404:
              this.error = 'We cannot find this user.';
              break;
            default:
              this.error = 'Something went wrong. Please try again later.';
          }
        }
      );
    },
    onSuccess() {
      this.$router.push({ name: 'adminUsersList' });
      this.$store.dispatch('users/setFlashMessage', {
        message: 'User has been updated successfully.'
      });
    }
  }
};
</script>
